import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import { reduxForm } from 'redux-form'

import ServiceAddress from './ServiceAddress'
import * as fromService from '@src/redux/modules/service'
import { createValidator, required } from 'utils/validations'

function addressValidation (fields) {
  const errorMessage = 'Requerido'
  const skippedFields = ['interiorNumber', 'postal_code_number']
  const errors =
    Object.keys(fields)
      .filter(field => !skippedFields.includes(field))
      .reduce((acc, fieldName) => {
        const value = fields[fieldName]
        const trimmedValue = typeof value === 'string' ? value.trim() : value
        const invalid = trimmedValue === ''
        if (invalid) {
          acc[fieldName] = errorMessage
        }
        return acc
      }, {})

  const errorCount = Object.keys(errors).length
  const hasError = errorCount > 0
  return hasError ? errors : undefined
}

let ServiceAddressContainer = reduxForm({
  form: 'ServiceAddress',
  validate: createValidator({
    address: [addressValidation],
    phone: [required],
    keysLocation: required
  })
})(ServiceAddress)

const mapStateToProps = (state, ownProps) => {
  const service = fromService.getService(state)

  const initialValues = {
    keysLocation: service.keysLocation,
    address: {
      street: '',
      number: '',
      interiorNumber: '',
      neighborhood: '',
      city: '',
      state: '',
      lat: 19.427022,
      lng: -99.167681
    }
  }

  return {
    initialValues
  }
}

const mapDispatchToProps = {
  updateService: fromService.updateNewService,
  push,
  goBack
}

ServiceAddressContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceAddressContainer)

export default ServiceAddressContainer



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/screens/ServiceAddress/ServiceAddressContainer.js